import axios from "../axiosPlugin.js";

export const createCinema = (data, loading = true) => {
  // console.log(data)
  return axios({
    url: "/api/cinema/create",
    method: 'post',
    data: {
      data,
      loading,
    },
  })
}

export const getCinemaDetail = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/cinema/detail/" + data.id,
    method: 'get',
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  })
}

export const updateCinema = (data, loading = true) => {
  // console.log(data)
  // return Promise.resolve({success:'true'})
  return axios({
    url: "/api/cinema/update",
    method: 'put',
    data: {
      data,
      loading
    },
  })
}

export const deleteCinema = (data, loading = true) => {
  return axios({
    url: "/api/cinema/delete/" + data.id,
    method: 'delete',
    data: {
      data: {},
      loading
    },
  })
}

export const getCinemaCode = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/cinema/cinemaNumber",
    method: 'get',
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  })
}

export const loginAsCinema = (data, loading = true) => {
  return axios({
    url: "/api/cinema/loginAs/" + data.id,
    method: 'get',
    data: {
      loading,
    },
  })
}

export const getBrandDetail = brandId => {
  return axios({
    url: "/api/brand/detail/" + brandId,
    method: 'get',
    data: {},
  })
}

export const getCscTrailerService = data => {
  return axios({
    url: "/api/cinema/getCscTrailer",
    method: "get",
    data: { data },
  });
}

export const updateCscTrailerService = data => {
  return axios({
    url: `/api/cinema/updateCscTrailer?id=${data.cinemaId}`,
    method: "post",
    data: { data: data.cinemaScsTrailer },
  });
};
